import { Model } from 'miragejs'

export default {
	area: Model,
	marker: Model,
}